import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HomepageService } from '../../services/homepage.service';
import { Observable, Subject, map, takeUntil, tap } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerCarouselComponent } from '@spartacus/core';
import { HomeTrackingService } from '../../services/homepage-tracking.service';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';

@Component({
  selector: 'app-homepage-carousel-section1',
  templateUrl: './homepage-carousel-section1.component.html',
  styleUrl: './homepage-carousel-section1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class HomepageCarouselSection1Component implements OnInit {

  //////ootb implementation/////
  carouselImages$: Observable<string[]>;
  activeIndex = 0;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private homePageService: HomepageService,
    private component: CmsComponentData<CmsBannerCarouselComponent>,
    private homeTrackingService: HomeTrackingService,
    private storageService: StorageService,
    private globalService: GlobalService,
  ) { }

  ///////OOTB implementation/////////////////
  ngOnInit() {
    this.fetchCarouselImages();
    this.getCarouselImages();
    this.updateActiveIndex();
    this.loadTrackingEvent();
  }

  fetchCarouselImages(): void {
    this.component.data$
      .pipe(
        map(data => {
          const arr: string[] = (data?.banners?.length > 0)
            ? data.banners.split(' ')
            : [];
          return arr;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(data => {
        this.homePageService.fetchCarouselImages(data)
      });
  }

  getCarouselImages(): void {
    this.carouselImages$ = this.homePageService.getCarouselImages();
  }

  prevSlide(lengthArray: number): void {
    this.activeIndex = (this.activeIndex > 0) ? --this.activeIndex : lengthArray - 1;
    this.updateActiveIndex();
  }

  nextSlide(lengthArray: number): void {
    this.activeIndex = (this.activeIndex < lengthArray - 1) ? ++this.activeIndex : 0;
    this.updateActiveIndex();
  }

  updateActiveIndex(): void {
    this.homePageService.updateCarouselImages(this.activeIndex);
  }

  loadTrackingEvent(): void {
    let legalEntityName: string = this.storageService?.defaultLegalEntity?.name || '';
    this.homeTrackingService.sendPageReadyData(legalEntityName);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }


  //////old implementation/////////
  // ngOnInit() {
  //   this.component.data$
  //     .pipe(
  //       map(data => {
  //         let arr: string[] = (data?.banners?.length > 0)
  //           ? data.banners.split(' ')
  //           : [];
  //         return arr;
  //       })
  //     )
  //     .subscribe(data => this.Homepageservice.getCarouselImages(data));

  //   this.Homepageservice.data$.subscribe((data: any) => {
  //     if (data?.length > 0) {
  //       this.array = [];
  //       for (const item of data) {
  //         this.array.push(environment.siteUrls.getBackofficeUrl + item.component?.at(0)?.media?.url);
  //       }
  //       this.lengthArray = this.array.length;
  //       this.setData(this.array);
  //       this.changeRef.markForCheck();
  //     }
  //   });

  //   this.subscription = interval(10000).subscribe(() => {
  //     this.i = ++this.current % this.listImg.length;
  //     this.changeRef.markForCheck();
  //   });
  // }

  // setData(a: any) {
  //   this.listImg = a;
  //   this.lengthArray = this.listImg.length;
  // }

  // prevSlide() {
  //   this.i = (this.i > 0) ? --this.i : this.lengthArray - 1;
  // }

  // nextSlide() {
  //   this.i = (this.i < this.lengthArray - 1) ? ++this.i : 0;
  // }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  //   this.globalService.clearMessagesOnDestroy();
  // }
}
